export default __webpack_public_path__ + "static/media/ARSHAGROVERMAKEUP.a8c7926e.pdf";